import Vue from 'vue'
import Vuex from 'vuex'
// 引入 axios
import axios from 'axios'
import apis from './../api/httpApi/index'
Vue.use(Vuex)

// vuex设置
export const store = new Vuex.Store({
  // modules: {
  // },
  // 定义状态
  state: {
    //登录token
    permission: {
      Istoken: false,
      token: '',
    },
    ItemProgramList: {},
    customer: null,
    //用户上传视频时用到的，其实可以和adminuser通用
    user: null,
    //tv类别
    TvCategory: [],
    //影片类型
    VideoCategory: [],
    currentIndex: 0,
    //管理员登录信息
    adminUser: null,
  },
  getters: {
    // 获取state中的类别数据
    getTvCategorygetters(state) {
      return state.TvCategory;
    },
    getPermission(state) {
      return state.permission
    },
    // 获取state中的类别数据
    getVideoCategorygetters(state) {
      return state.VideoCategory;
    },
    getUser(state) {
      return state.user;
    },
    getAdminUser(state) {
      return state.adminUser;
    },
    getcustomer(state) {
      return state.customer;
    },
    getCurrentIndex(state) {
      return state.currentIndex
    }
    // 在组件里可以通过this.$store.getters.getXXgetters调用 也可以用...mapgetters:({‘方法名’})
  },
  mutations: {
    // 在组件里可以通过this.$store.commit('getXXmutations',参数)调用
    //登录 拿到用户cookie 请求接口
    updatePermission(state, payload) {
      if (payload == null) {
        state.permission.Istoken = false;
        state.permission.token = null;

      } else {
        //拿到token存入store
        state.permission.Istoken = payload.data.success;
        if (payload.data.result != null) {
          state.permission.token = payload.data.result.accessToken;
        } else {
          state.permission.token = null;
        }
      }
    },
    updateCurrentIndex(state, payload) {
      state.currentIndex = payload;
    },

    // //根据节目Id获取节目的集数
    getItemProgramList(state, payload) {
      apis.VideoApi.getItemProgramList(payload).then(result => {
        state.ItemProgramList = result.data.data
      })
    },

    //将TV分类写入state
    writeTvcategory(state, payload) {
      state.TvCategory = payload
    },
    writeVideoCategory(state, payload) {
      state.VideoCategory = payload
    },
    writeUser(state, payload) {
      state.user = payload
    },
    writecustomer(state, payload) {
      state.customer = payload
    },
    writeAdminUser(state, payload) {
      state.adminUser = payload
    },
    updateCheckStatus(state, payload) {
      if (state.customer) {
        state.customer.sgL_IsCheck = payload;
      }
    }
  },
  actions: {
    //登录
    Login(context, payload) {
      return new Promise(reslove => {
        //請求登錄接口
        apis.VideoApi.Login(payload).then(res => {
          if (res != null && res.data != null && res.data.success == true) {
            //登录成功写入store数据
            context.commit('updatePermission', res)
            reslove(true)
          } else {
            reslove(false)
          }
        }).catch(res => reslove(false));
      });

    },
    //用户登录
    userlogin(context, payload) {
      return new Promise(reslove => {
        apis.common.UserLogin(payload).then(res => {
          if (res != null && res.data != null && res.data.success == true) {
            //登录成功写入store数据
            context.commit('writecustomer', res.data.result)
            context.commit('updatePermission', res);
            sessionStorage.setItem("store", JSON.stringify(this.state));
            reslove(true)
          } else {
            reslove(false)
          }
        }).catch(res => reslove(false));
      })
    },
    //管理员登录、将信息写入state
    adminLogin(context, payload) {
      return new Promise(reslove => {
        apis.common.Login(payload).then(res => {
          if (res != null && res.data != null && res.data.success == true) {
            //登录成功写入store数据
            context.commit('writeAdminUser', res.data.result)
            context.commit('updatePermission', res)
            context.commit('writeUser', res.data.result)
            sessionStorage.setItem("store", JSON.stringify(this.state));
            // localStorage.setItem("sessionStorageData", JSON.stringify(this.state));
            // localStorage.removeItem("sessionStorageData");
            reslove(true)
          } else {
            reslove(false)
          }
        }).catch(res => reslove(false));
      })
    },
    //管理员face登录、将信息写入state
    adminFaceLogin(context, payload) {
      return new Promise(reslove => {
        apis.common.UserLogin(payload).then(res => {
          if (res != null && res.data != null && res.data.success == true) {
            if (res.data.result.isAdmin) {
              //登录成功写入store数据
              context.commit('writeAdminUser', res.data.result)
              context.commit('updatePermission', res)
              context.commit('writeUser', res.data.result)
              sessionStorage.setItem("store", JSON.stringify(this.state));
              reslove(true)
            } else {
              reslove(false)
            }
          } else {
            reslove(false)
          }
        }).catch(res => reslove(false));
      })
    },
    //获取cookie
    getCookie(context, payload) {
      let user = "";
      let name = payload + "=";
      let ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) {
          user = c.substring(name.length, c.length);
        }
      }
      return user;
    },
    // 根据节目Id获取节目的集数
    getItemProgramList(context, payload) {
      context.commit('getItemProgramList', payload);
    },
    //獲取公共類型
    getCommonType(context, payload) {
      return new Promise(reslove => {
        let params = {
          SGL_TypeT: payload,
        };
        apis.EventApi.GetEventType(params).then((res) => {
          if (res.data.success) {
            reslove(res.data.result.items);
          } else {
            reslove(null)
          }
        }).catch(res => reslove(null));
      });
    },
    getCommonTypeDesk(context, payload) {
      return new Promise(reslove => {
        let params = {
          SGL_TypeT: payload,
          SkipCount: 0,
          MaxResultCount: 999
        };
        apis.EventApi.GetEventTypeDesk(params).then((res) => {
          if (res.data.success) {
            reslove(res.data.result.items);
          } else {
            reslove(null)
          }
        }).catch(res => reslove(null));
      });
    },
    //收藏
    addfavorite(context, payload) {
      return new Promise(reslove => {
        let state = false;
        apis.commons.addFavorite(payload).then((res) => {
          if (res.data.success) {
            state = true;
          }
          reslove(state);
        }).catch(res => reslove(false));
      });
    },
    //将TV分类写入state
    writeTvcategory(context, payload) {
      context.commit('writeTvcategory', payload);
    },
    //将video分类写入state
    writeVideoCategory(context, payload) {
      context.commit('writeVideoCategory', payload)
    },
    updateCurrentIndex(context, payload) {
      context.commit('updateCurrentIndex', payload)
    },
    // 封装一个方法,一般都是用来做异步请求 payload接受参数
    getxxactions: (context, payload) => {
      context.commit('getXXmutations')
      return 'xx'
      // 组件里调用 this.$store.dispatch("getxxactions",payload)  分发 也可以用...mapactions:({‘方法名’})
    }
    // 封装一个 ajax 方法
    // saveForm (context) {
    //   axios({
    //     method: 'post',
    //     url: '/user',
    //     data: context.state.test02
    //   })
    // }
  }
})
// 导出store实例
export default store



// WEBPACK FOOTER //
// ./src/store/store.js